<template>
  <ul class="gift-list">
    <li
      class="gift-item"
      v-for="(gift,index) in gifts"
      :key="`gift-${index}`"
      v-show="gifts.length > 0"
    >
      <i
        class="gift-state-icon"
        v-bind:class="{ recieved: gift.type == 'member_gift',recieveAble: gift.type=='novice_gift' }"
      ></i>
      <div>
        <p
          class="gift-name"
          v-bind:class="{ recievedText: gift.state,recieveAbleText: !gift.state }"
        >{{gift.name}}</p>
        <div>
          <span class="less-tips">剩余</span>
          <progress class="less-process" v-bind:value="gift.less/gift.totalNum" max="1"></progress>
          <output class="less-rate">{{parseInt(gift.less/gift.totalNum*100)}}%</output>
        </div>
      </div>
      <button v-if="gift.state" class="recieve-btn" v-on:click="getGift(gift.type)">領取</button>
      <button v-if="!gift.state" class="recieve-btn" v-on:click="checkGift(gift.type)">查看</button>
    </li>
    <div class="gift-empty" v-show="gifts.length < 1"></div>
    <div class="gift-tips" v-if="gifts.length >= 1">注：此處禮包和遊戲APP內的禮包為同一個，無法重複兌換</div>
  </ul>
</template>

<script>
import user from "../store/gift";
import { bus } from "../utile/index";
export default {
  data() {
    return {};
  },
  created() {
    this.$store.dispatch("loadGiftList");
  },
  computed: {
    gifts() {
      return user.state.giftList;
    },
  },
  methods: {
    getGift(type) {
      this.$store.dispatch("recieveGift", { type: type }).then(() => {
        this.$emit("showPopupWindow");
        this.$store.dispatch("loadGiftList");
      });
    },
    checkGift(type) {
      this.$store.dispatch("checkGift", type).then(() => {
        this.$emit("showPopupWindow");
      });
    },
  },
  name: "Gift",
};
</script>


<style lang="scss">
$divide: 10 !default;
$pswWidth: 640;
$imgURL: "../assets/img/";
.gift-list {
  width: 100%;
  padding-bottom: 10px;
  background: #fdf6c7;
}
.gift-item {
  position: relative;
  width: 100%;
  height: 114px;
  box-sizing: border-box;
  padding-left: 120px;
  padding-right: 149px;
  margin-top: 10px;
  background: white;
  border-bottom: 1px solid #e9e4ca;
  &:first-child {
    margin-top: 20px;
  }
}

.gift-state-icon {
  position: absolute;
  left: 20px;
  top: 19px;
  height: 77px;
  width: 77px;
  border-radius: 77px;
  display: block;
  background-size: 100% 100%;
  &.recieved {
    background-image: url($imgURL + "gift-received.png");
  }
  &.recieveAble {
    background-image: url($imgURL + "gift-receiveAble.png");
  }
}
.recieve-btn {
  position: absolute;
  right: 20px;
  top: 26px;
  width: 118px;
  height: 58px;
  line-height: 58px;
  text-align: center;
  font-size: 14px;
  color: #f87e19;
  padding: 0;
  border: 2px solid #f87e19;
  border-radius: 10px;
  background: transparent;
  cursor: pointer;
}
.gift-name {
  padding-top: 27px;
  padding-bottom: 18px;
  width: 100%;
  line-height: 100%;
  font-size: 20px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  &.recievedText {
    color: #76cf1f;
  }
  &.recieveAbleText {
    color: #54b2ee;
  }
}
.less-tips {
  display: block;
  float: left;
  font-size: 16px;
  line-height: 100%;
  color: #aaa;
}
.less-process {
  display: block;
  float: left;
  margin-top: 5px;
  margin-left: 8px;
  width: 180px;
  height: 10px;
  background: #cecece;
  border-radius: 10px;
  border: 0;
  &::-webkit-progress-bar {
    background: #cecece;
    border-radius: 10px;
  }
  &::-webkit-progress-value {
    background: #f87e19;
    border-radius: 10px;
  }
}
.less-rate {
  display: block;
  line-height: 100%;
  color: #f87e19;
  float: right;
  font-size: 16px;
}
.gift-empty {
  background: url($imgURL + "noGift.png");
  width: 361px;
  height: 417px;
  background-size: contain;
  margin: 40px auto auto;
}
.gift-tips {
  padding: 40px;
  white-space: pre-wrap;
  word-break: break-all;
  font-size: 20px;
  line-height: 28px;
}
</style>



// WEBPACK FOOTER //
// src/components/Gift.vue